import router from "./router";
import store from "./store";

import NProgress from "nprogress";
import notification from "ant-design-vue/es/notification";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["Login", "AppLookPPT"]; // no redirect whitelist 白名单
const defaultRoutePath = "/home";

router.beforeEach((to, from, next) => {
  NProgress.start();

  to.meta && typeof to.meta.title !== "undefined";

  if (localStorage.getItem("token")) {
    if (to.path === "/login") {
      next({ path: defaultRoutePath });
      NProgress.done();
    } else {
      if (store.state.user.userInfo === "") {
        store
          .dispatch("GetUserInfo")
          .then((res) => {
            console.log(res, "GetUserInfo");
            const redirect = decodeURIComponent(to.path);
            if (to.path === redirect) {
              next({ ...to, replace: true });
            } else {
              next({ path: redirect });
            }
          })
          .catch((err) => {
            console.log(err, "err");
            notification.error({
              message: "错误",
              description: "请求用户信息失败，请重试"
            });
            store.dispatch("Logout").then(() => {
              next({ path: "/login" });
            });
          });
      } else {
        next();
      }
    }
  } else {
    console.log(to.name, "to.name");
    if (whiteList.includes(to.name)) {
      next();
    } else {
      next({ path: "/login" });
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
